export default class NavigationError extends Error {
  navigateTo: string;
  constructor(navigateTo: string) {
    super(`Navigation error! Navigating to ${navigateTo}`);
    this.name = "NavigationError";
    this.navigateTo = navigateTo;
  }
}
